<ion-content class="wrapper">

  <div class="header">
    <p class="title">Doorgegeven order</p>
  </div>

  <div class="order__location">
    <div>
      <ion-icon src="../../assets/icon/location.svg"></ion-icon>
    </div>
    <div class="container-address">
      <p class="address">{{ data.client.getAddress() }}</p>
    </div>
  </div>
  <div class="order">
    <div>
      <p class="order__time"> Besteld om <span class="time__value">{{ data.order.placedAt | date: 'H:mm' }}</span>
      </p>
      <p class="order__name"> Bestelling voor {{ data.client.name }}</p>
      <p class="order__payment-type"> {{ data.order.paymentType }} </p>
    </div>

    <div class="order__list">
      <ion-list>
        <ion-item *ngFor="let orderLine of data.order.orderLines" class="order__item">
          <img src="../../../../assets/icon/pizza.png" />
          <p class="order__item-text">{{ orderLine.count }} x {{ orderLine.article }} {{ orderLine.size }} - {{
            orderLine.price | currency: 'EUR' }}</p>
        </ion-item>
      </ion-list>
    </div>

    <p class="order__total">TOTAAL: {{ data.order.totalPrice | currency: 'EUR'}} </p>
  </div>

  <div class="action-buttons">
    <ion-button class="decline" (click)="decline()">
      Afwijzen
    </ion-button>
    <ion-button class="accept" (click)="accept()">
      Accepteren
    </ion-button>
  </div>
</ion-content>